module.exports = __webpack_public_path__ + "static/media/vue.940fb2b1.svg";